import React from 'react';
import { useMutation } from '@common/hooks';
import { BaseButton, Icon } from '@common/components';
import { createMessage } from 'works/legacy/lib/message-helper';
import { CreateWorksListComplianceDocsExportMutation } from '@onboarding/graphql';

type Props = {
  worksListId: string;
  hasAttachments: boolean;
};

export function DownloadAllButton({ worksListId, hasAttachments }: Props) {
  const [createExport, { loading }] = useMutation(
    CreateWorksListComplianceDocsExportMutation,
    {
      onCompleted: () => {
        createMessage(
          'success',
          'We are preparing your documents. You will receive an email with a download link shortly.'
        );
      },
      onError: () => {
        createMessage('error', 'Failed to start compliance documents export');
      },
    }
  );

  if (!hasAttachments) return null;

  const handleDownload = () => {
    createExport({
      variables: { worksListId },
    });
  };

  return (
    <BaseButton
      icon={<Icon icon="arrowDownToBracket" kind="regular" />}
      onClick={handleDownload}
      loading={loading}
    >
      Download All
    </BaseButton>
  );
}
